<mat-table #table [dataSource]="dataSource" matSort matSortActive="created_at" matSortDirection="desc"
    matSortDisableClear [@animateStagger]="{value:'50'}">

    <!-- Employee recommendation Name Column -->
    <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Name' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let recommendation">
            <p class="text-truncate font-weight-600">{{recommendation.first_name}} {{recommendation.last_name}}</p>
        </mat-cell>
    </ng-container>

    <!-- Status Column -->
    <ng-container matColumnDef="date_of_birth">
        <mat-header-cell *matHeaderCellDef mat-sort-header  fxHide.xs>{{'Date of Birth' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let recommendation"  fxHide.xs>
            <p class="text-truncate font-weight-600">{{recommendation.date_of_birth}}</p>
        </mat-cell>
    </ng-container>

    <!-- Comment Column -->
    <ng-container matColumnDef="email">
        <mat-header-cell *matHeaderCellDef mat-sort-header>{{'Email' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let recommendation">
            <p class="text-truncate font-weight-600">{{recommendation.email}}</p>
        </mat-cell>
    </ng-container>

    <!-- Created at Column -->
    <ng-container matColumnDef="created_at">
        <mat-header-cell *matHeaderCellDef mat-sort-header  fxHide.xs>{{'Date of Creation' | translate }}</mat-header-cell>
        <mat-cell *matCellDef="let recommendation"  fxHide.xs>
            <p class="text-truncate font-weight-600">{{recommendation.created_at}}</p>
        </mat-cell>
    </ng-container>

    <mat-header-row *matHeaderRowDef="displayedColumns"></mat-header-row>
    <mat-row *matRowDef="let recommendation; columns: displayedColumns;" class="recommendation" matRipple
        [@animate]="{value:'*',params:{y:'100%'}}">
    </mat-row>

</mat-table>
<mat-paginator #paginator [length]="totalElements" [pageSize]="pageSize" [pageSizeOptions]="[5, 10, 25]"
    [hidePageSize]="true" [fxHide]="totalElements === 0">
</mat-paginator>